import { apiRequest } from "../_core/apiRequest";

export async function changeProfileImage(base64Image) {
  return apiRequest({
    method: "put",
    path: "/profile/avatar",
    data: { base64_image: base64Image },
    errorMessage: "Erro ao atualizar imagem de perfil",
  });
}
